<template>
    <div id="detail_image"
        :class="{'img-bg-white' : isSurvey}"
        v-if="campaignImage">
        <div v-if="campaignImage.length > 1">
            <carousel id="detail_carousel"
                :responsive="carouselConfig.responsive"
                :lazyLoad="true"
                :nav="false"
                :rewind="false"
                :loop="true"
                :autoplay="false"
                :item="1">
                <div class="detail-img"
                    :class="!isSurvey ? imgCampaignClass : 'img-product'"
                    v-for="(image, k) in campaignImage" :key="k">
                        <div class="img-flag" v-if="campaignQty <= 0">สิทธิ์เต็ม</div>
                        <div class="img-filter" v-if="campaignQty <= 0"></div>
                        <div class="img-campaign" 
                            :class="!isSurvey ? imgCampaignClass : 'square'">
                                <img :src="image.fullImageUrl" class="img-fluid" />
                        </div>
                </div>
            </carousel>
        </div>
        <div class="detail-img"
            :class="!isSurvey ? imgCampaignClass : 'img-product'"
            v-if="campaignImage.length == 1">
                <div class="img-flag" v-if="campaignQty <= 0">สิทธิ์เต็ม</div>
                <div class="img-filter" v-if="campaignQty <= 0"></div>
                <div class="img-campaign" 
                    :class="!isSurvey ? imgCampaignClass : 'square'">
                        <img :src="campaignImage[0].fullImageUrl" class="img-fluid" />
                </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import Carousel from "vue-owl-carousel";

export default {
    name: "Picture",
    components: {
        Carousel
    },
    props: {
        imgCls: String,
        campaign: Object,
        campaignImage: Array,
        campaignQty: Number,
    },
    data: function() {
        return {
            imgCampaignClass: '',
            carouselConfig: {
                responsive: {
                    0: { items: 1 }
                }
            },
            isSurvey: false,
        };
    },
    created: function () {
        this.imgCampaignClass = this.imgCls || 'default';
        this.checkSurvey();
    },
    methods: {
        checkSurvey : function(){
            if (this.campaign.type == Vue.CampaignType.Interface) {
                if(this.campaign.interfaceDisplay == 'surveyapprove') {
                    this.isSurvey = true;
                }
            } 
            console.log('cam', this.campaign)
        }
    }
};
</script>
<style lang="scss" scoped>

</style>
<style lang="scss">
    @import "@/style/base/base.scss";
    @import "@/style/base/baseImage.scss";
    @import "@/style/custom/owl.scss";
    #detail_image {
        border-bottom-left-radius: 30px;
        border-bottom-right-radius: 30px;
        overflow: hidden;

        &.img-bg-white{
            background-color: $white;
        }
    }

    .detail-img {
        width: 100%;
        position: relative;

        &.img-product{
            width: 53%;
            margin: auto;
        }

        .img-filter{
            width: 100%;
            height: 100%;
            background-color: $dark-blue;
            opacity: 0.55;
            position: absolute;
            z-index: 1;               
        }

        .img-flag{
            width: 120px;
            height: 120px;
            background-color: $dark-blue;
            border-radius: 50%;
            color: $white;
            font-size: 1.25rem;
            text-align: center;
            margin: auto;
            padding: 45px 0;
            position: absolute;
            z-index: 2;
            left: 0;
            right: 0;
            top: 25%;
            opacity: 0.9;

            @include mini-mobile(){
                width: 100px;
                height: 100px;
                font-size: 1rem;
                padding: 38px 0;
            }
        }

        .img-campaign{
            &.default {
                @include baseRatioImg(66.67%);
            }
            &.square{
                @include baseRatioImg(100%);
                margin: 30px 0;
            }
        } 
    }

    #detail_carousel {
        .owl-dots {
            position: absolute;
            z-index: 999;
            left: 0;
            right: 0;
            bottom: 5px;

            .owl-dot {
                &.active {
                    span {
                        width: 17px;
                        height: 6px;
                        margin: 0 3px;
                        border-radius: 10px;
                        background-color: $blue-gray;
                        opacity: 1;
                    }
                }
                span {
                    width: 6px;
                    height: 6px;
                    margin: 0 3px;
                    border-radius: 10px;
                    background-color: $blue-gray;
                    opacity: 0.41;
                }
            }
        }
    }
</style>

